import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
  // position: absolute;
  font-family: BrandonGrotesque-Regular;
  // bottom: 10px;
  // left: 25px;
  display: inline-block;
  width: 97px;
  height: 40px;
  font-size: 14px;
  border-radius: 2px;
  line-height: 45px;
  color: var(--color-cool-grey);
  background-color: var(--color-beige);
  cursor: pointer;
`;

export default function BackButton(props: { click: Function }) {
  return (
    <Button onClick={props.click} style={{  marginRight: '10px' }}>
      <div className="float-right" style={{ paddingRight: '15px' }}>
        BACK
      </div>
      <div className="float-left" style={{ marginTop: '-2px', paddingLeft: '18px' }}>
        <svg width="10" height="9" xmlns="http://www.w3.org/2000/svg">
          <path d="M.058 3.862c.017-.029.034-.053.05-.083a.715.715 0 0 1 .109-.16.573.573 0 0 1 .091-.069L2.442.399c.293-.389.824-.51 1.258-.29a.726.726 0 0 1 .342 1.08l-1.45 2.147h6.575a.832.832 0 1 1 0 1.662H2.592l1.45 2.146a.725.725 0 0 1-.342 1.08c-.434.22-.964.099-1.258-.289L.325 4.81a.128.128 0 0 1-.033-.04.9.9 0 0 1-.184-.211.696.696 0 0 1-.091-.31c-.007-.022-.01-.032-.009-.042 0-.013-.008-.024-.008-.038 0-.013.008-.026.008-.038a.04.04 0 0 1 .009-.03.923.923 0 0 1 .041-.238z" fill="#909798" fillRule="evenodd"/>
        </svg>
      </div>
    </Button>
  );
}
